export const AUTH_KEY = 'auth._token.local'

export function getStoredAuthToken() {
  if (import.meta.env.SSR === false) return localStorage.getItem(AUTH_KEY)
  return ''
}

export function storeAuthToken(token) {
  if (import.meta.env.SSR === false) {
    document.cookie = `${AUTH_KEY}=Bearer ${token}`
    return localStorage.setItem(AUTH_KEY, 'Bearer ' + token)
  }
  return ''
}

export function removeStoredAuthToken() {
  if (import.meta.env.SSR === false) {
    document.cookie = `${AUTH_KEY}=`
    return localStorage.removeItem(AUTH_KEY)
  }
  return ''
}
